import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { checkValidResponse, logError } from '@cigna/chcp/shared/util';

import {
  GetUserAlertsResponse,
  UpdateUserAlertsResponse,
  UserAlert,
  UserAlertStatus,
  UserAlertUpdates,
} from './user-alerts.model';

@Injectable({ providedIn: 'root' })
export class UserAlertsService {
  public userAlertsApi: string;

  constructor(
    private http: HttpClient,
    @Inject('secureApi') secureApi: string,
  ) {
    this.userAlertsApi = `${secureApi}/identity/alerts/user`;
  }

  getUserAlerts(status?: UserAlertStatus): Observable<UserAlert[]> {
    const options = status
      ? { params: new HttpParams().set('status', status) }
      : {};

    return this.http
      .get<GetUserAlertsResponse>(this.userAlertsApi, options)
      .pipe(
        map(checkValidResponse),
        map((response: GetUserAlertsResponse) => response.alerts),
        catchError((error) => logError(error) as Observable<never>),
      );
  }

  updateUserAlerts(
    updates: UserAlertUpdates,
  ): Observable<UpdateUserAlertsResponse> {
    return this.http
      .post<UpdateUserAlertsResponse>(this.userAlertsApi, updates)
      .pipe(
        map(checkValidResponse),
        catchError((error) => logError(error) as Observable<never>),
      );
  }
}
